import React, { lazy, Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function WhereSection() {
  const {
    t,
    lang
  } = useLanguage();
  const msg = lang === 'es' ? '¿Cuándo es el próximo taller de constelaciones?' : 'Quan és el proper taller de constel·lacions?';
  const waLink = `https://wa.me/34671636887?text=${encodeURIComponent(msg)}`;
  return <section id="donde" className="py-16 sm:py-20 md:py-32 px-4 sm:px-6 bg-cream relative" data-id="element-861">
      <div className="max-w-5xl mx-auto" data-id="element-862">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-16" data-id="element-863">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-forest-dark mb-6 uppercase leading-tight" data-id="element-864">
            {t('nav.where')}
          </h2>
          <div className="w-16 h-[1px] bg-terracotta mx-auto mb-8" data-id="element-865"></div>
          <p className="text-xl sm:text-2xl md:text-3xl font-serif text-forest-dark italic mb-6 leading-snug" data-id="element-866">
            {t('where.title')}
          </p>
          <p className="text-2xl md:text-4xl font-serif text-forest-dark font-bold mb-10" data-id="element-867">
            {t('where.main_location')}
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-868">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8 text-lg text-forest/80 font-light leading-relaxed" data-id="element-869">
            <p className="text-xl font-serif text-forest-dark italic" data-id="element-870">
              {t('where.also_label')}
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-871">
              {(t('where.locations') as string[]).map((loc, i) => <li key={i} data-id="element-872">{loc}</li>)}
            </ul>
            <p data-id="element-873">{t('where.p3')}</p>
            <p data-id="element-874">{t('where.p4')}</p>

            <div className="pt-8" data-id="element-875">
              <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white font-medium rounded-full hover:bg-[#20BD5A] transition-colors shadow-lg w-full sm:w-auto mb-4" data-id="element-876">
                <MessageCircle className="w-5 h-5" data-id="element-877" />
                {t('where.btn_wa')}
              </a>
              <br data-id="element-878" />
              <a href="#contacto" className="inline-flex items-center justify-center px-8 py-4 bg-gold text-forest-dark font-bold tracking-widest uppercase rounded-full hover:bg-gold-light transition-colors shadow-lg w-full sm:w-auto" data-id="element-879">
                {t('where.cta')}
              </a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="rounded-[3rem] overflow-hidden shadow-xl border border-sage-light/30 h-[500px]" data-id="element-880">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47895.83983226777!2d1.6622839499999998!3d41.34689035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a468c819586143%3A0x400fae021a42330!2sVilafranca%20del%20Pened%C3%A8s%2C%20Barcelona!5e0!3m2!1sen!2ses!4v1715000000000!5m2!1sen!2ses" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Vilafranca del Penedès Map" data-id="element-881"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}